import moment from 'moment';
export class LegacySignupRequestToLegacySignupRequestDtoConverter {
    static create = () => {
        return new LegacySignupRequestToLegacySignupRequestDtoConverter();
    };
    toModel = (source) => {
        return {
            firstName: source.firstName,
            middleName: source.middleName,
            lastName: source.lastName,
            email: source.email,
            userName: source.userName,
            password: source.password,
            day: moment(source.dateOfBirth).date(),
            month: moment(source.dateOfBirth).month() + 1,
            year: moment(source.dateOfBirth).year(),
            parentRequest: source.guardianRequest ?? false,
            parentFirstName: source.guardianFirstName,
            parentLastName: source.guardianLastName,
            parentDay: source.guardianDateOfBirth ? moment(source.guardianDateOfBirth).date() : undefined,
            parentMonth: source.guardianDateOfBirth ? moment(source.guardianDateOfBirth).month() + 1 : undefined,
            parentYear: source.guardianDateOfBirth ? moment(source.guardianDateOfBirth).year() : undefined,
            captchaResponse: source.captcha,
            duplicateWarningDisplayed: source.duplicateWarningDisplayed
        };
    };
}
